import { IServices } from "@netent/origin";
import { IBetState } from "@netent/playui";
import { FeatureStateCreator } from "../../types";

export const betState: FeatureStateCreator<IBetState> = ({
  bet,
  gameRound
}: IServices): IBetState => ({
  enabled: !gameRound.isRoundActive(),
  denominations: bet.getDenominations(),
  denomination: bet.getDenomination(),
  size: bet.getBetSize(),
  level: bet.getBetLevel(),
  levels: bet.getBetLevels(),
  valueInCoins: bet.getBetCoins(),
  valueInCash: bet.getBetCash()
});
